import React, { useEffect, useRef, useState } from 'react'
import { Button, Grid, TextField } from '@mui/material';
import axios from 'axios';
import Loading from './Loading';
import { GridAutoTextField } from './GridComponents';

import {trainingLanguageCourse, zoomOnlyCourseId } from '../../constants/global.js'

// consider consolidating these down to one component, maybe takes in an array of components, such as
// [{type: 'TextField', name: 'lastName', label: 'Last Name'}]
// onSearch=~, disabled (this may be difficult, perhaps pass a function like checkSearch(search){return search.username && search.lastName})
// useMem, key='searchFirstLast'
// defaultVal={firstName:'',lastName:''}

// CURRENTLY
// takes in a classes and onSearch prop

export const SearchBarUserFirstLastRequired = props => {
    const { classes } = props

    const [search, setSearch] = useState({ username: '', firstName: '', lastName: '', email: '' })
    const [disabled, setDisabled] = useState(true) // if the search button is disabled or not

    // save the search state on save, if the state was saved then load it in
    useEffect(() => {
        const memory = JSON.parse(sessionStorage.getItem('searchUserFirstLast'));
        if (memory) setSearch(memory)

    }, [])

    // handle the button disabling if both fields are undefined
    useEffect(() => {
        if (search.username === '' && search.lastName === '' && search.firstName === '' && search.email === '' ) setDisabled(true)
        else setDisabled(false)
    }, [search.username, search.lastName, search.firstName, search.email])


    // handle updating state
    const handleChange = event => {
        event.persist()
        const { name, value } = event.target

        setSearch(prevSearch => ({
            ...prevSearch,
            [name]: value
        }))
    }

    const handleSearch = () => {
        sessionStorage.setItem('searchUserFirstLast', JSON.stringify(search))
        props.onSearch(search)
    }

    const handleClearSearch = () => {
        sessionStorage.removeItem('searchUserFirstLast')
        setSearch({
            username: '', 
            firstName: '', 
            lastName: '',
            email: ''
        })
        props.clearSearch()
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={2}>
                <TextField
                    name='username'
                    label="Username"
                    type="text"
                    value={search.username}
                    className={[classes.textField].join(' ')}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <TextField
                    name='firstName'
                    label="First Name"
                    type="text"
                    value={search.firstName}
                    className={[classes.textField].join(' ')}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={2}>
                <TextField
                    name='lastName'
                    label="Last Name"
                    type="text"
                    value={search.lastName}
                    className={[classes.textField].join(' ')}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    fullWidth
                />
            </Grid>

            <Grid item xs={12} sm={3}>
                <TextField
                    name='email'
                    label="Email"
                    type="text"
                    value={search.email}
                    className={[classes.textField].join(' ')}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    fullWidth
                />
            </Grid>

            <Grid item  xs={12} sm={1} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                     <Button disabled={disabled} variant="contained" color="primary" type="submit" 
                     className={[].join(' ')} onClick={handleSearch} >Search</Button>
            </Grid>
                
            <Grid item xs={12} sm={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                   <Button disabled={disabled} variant="contained" color="primary" 
                   className={[].join(' ')} onClick={handleClearSearch} > Clear </Button>
            </Grid>

           

            <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }} >
                {disabled && <p>Enter a username or last name</p>}
            </Grid>
            
        </Grid>
    )
}

export const SearchBarFirstLastRequired = props => {
    const { classes, onSearch } = props

    const [search, setSearch] = useState({ firstName: '', lastName: '' })
    const [disabled, setDisabled] = useState(true) // if the search button is disabled or not

    // handle the button disabling if last name is undefined
    useEffect(() => {
        if (search.lastName === '') setDisabled(true)
        else setDisabled(false)
    }, [search.lastName])

    // save the search state on save, if the state was saved then load it in
    useEffect(() => {
        const memory = JSON.parse(sessionStorage.getItem('searchFirstLast'));
        if (memory) setSearch(memory)

    }, [])


    // handle updating state
    const handleChange = event => {
        event.persist()
        const { name, value } = event.target

        setSearch(prevSearch => ({
            ...prevSearch,
            [name]: value
        }))
    }

    const handleSearch = () => {
        sessionStorage.setItem('searchFirstLast', JSON.stringify(search))
        onSearch(search)
    }

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={5}>
                <TextField
                    name='firstName'
                    label="First Name"
                    type="text"
                    value={search.firstName}
                    className={[classes.textField].join(' ')}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12} sm={5}>
                <TextField
                    name='lastName'
                    label="Last Name"
                    type="text"
                    value={search.lastName}
                    className={[classes.textField].join(' ')}
                    onChange={handleChange}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={12}  sm={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                <Button disabled={disabled} variant="contained" color="primary" type="submit" className={[].join(' ')} onClick={handleSearch} >Search</Button>
                {disabled && <p>Enter a last name</p>}
            </Grid>
        </Grid>
    )
}


export const SearchBarCatLevelRegionFirstLast = props => {
    const { classes, onSearch, onClear } = props
    const mounted = useRef(true)

    const [loading, setLoading] = useState(true)
    const [options, setOptions] = useState({
        category: null,
        level: null,
        county: null,
        region: null, // geo group/region
        inStatus: null, // instructor status

    })
    const [search, setSearch] = useState({
        category: null,
        level: null,
        county: null,
        region: null,
        inStatus: null,
        firstName: '',
        lastName: ''
    })


    useEffect(() => {
        // grab options data
        axios.all([
            axios.get('/api/category'),
            axios.get('/api/instructor/levels'),
            axios.get('/api/instructor/status'),
            axios.get('/api/stateCounty/county/FL'),
            axios.get('/api/geoGroup')
        ]).then((res) => {
            const category = res[0].data.categories.map((u) => ({ label: u.categoryName, value: u.ID }))
            const level = res[1].data.levels.map((u) => ({ label: u.value, value: u.id }))
            const inStatus = res[2].data.inStatus.map((u) => ({ label: u.value, value: u.id }))
            const county = res[3].data.map((u) => ({ label: u.stateCountyName, value: u.stateCountyName }))
            const region = res[4].data.geogroups.map((u) => ({ label: u.name, value: u.ID }))

            if (mounted.current) {
                setOptions({
                    category,
                    level,
                    inStatus,
                    county,
                    region,
                })

                const memory = JSON.parse(sessionStorage.getItem('searchCatLevelRegionFirstLast'));
                if (memory) setSearch(memory)

                setLoading(false)
            }
        })

        // on unmount
        return () => mounted.current = false
    }, [])


    // handle updating state
    const handleChange = event => {
        event.persist()
        const { name, value } = event.target

        setSearch(prevSearch => ({
            ...prevSearch,
            [name]: value
        }))
    }

    const handleSearch = () => {
        sessionStorage.setItem('searchCatLevelRegionFirstLast', JSON.stringify(search))
        onSearch(search)
    }

    const handleClearSearch = () => {
        onClear()
        setSearch({
            category: null,
            level: null,
            inStatus: null,
            county: null,
            region: null,
            firstName: '',
            lastName: ''
        })
    }

    return (
        <>
            {loading ? <Loading /> :
                <Grid container spacing={3} >
                    <GridAutoTextField
                        xs={12}
                        md={3}
                        name="category"
                        options={options.category}
                        value={search.category}
                        onChange={handleChange}
                        classes={classes}
                        label="Category"
                    />
                    <GridAutoTextField
                        xs={12}
                        md={3}
                        name="level"
                        options={options.level}
                        value={search.level}
                        onChange={handleChange}
                        classes={classes}
                        label="Instructor Level"
                    />
                     <GridAutoTextField
                        xs={12}
                        md={3}
                        name="inStatus"
                        options={options.inStatus}
                        value={search.inStatus}
                        onChange={handleChange}
                        classes={classes}
                        label="Status"
                    />
                      <GridAutoTextField
                        xs={12}
                        md={3}
                        name="county"
                        options={options.county}
                        value={search.county}
                        onChange={handleChange}
                        classes={classes}
                        label="County"
                    />
                    <GridAutoTextField
                        xs={12}
                        md={3}
                        name="region"
                        options={options.region}
                        value={search.region}
                        onChange={handleChange}
                        classes={classes}
                        label="Region"
                    />
                    <Grid item xs={12} sm={3}>
                        <TextField
                            name='firstName'
                            label="First Name"
                            type="text"
                            value={search.firstName}
                            className={[classes.textField].join(' ')}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            name='lastName'
                            label="Last Name"
                            type="text"
                            value={search.lastName}
                            className={[classes.textField].join(' ')}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            fullWidth
                        />
                    </Grid>

                    <Grid item  xs={12} sm={2} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                        <Button variant="contained" color="primary" type="submit" 
                        className={[].join(' ')} onClick={handleSearch} >Search</Button>
                    </Grid>
                        
                    <Grid item  xs={12} sm={1} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                        <Button variant="contained" color="primary" 
                        className={[].join(' ')} onClick={handleClearSearch} > Clear </Button>
                    </Grid>
                    
                </Grid>}
        </>
    )
}


export const SearchBarTrainingReport = props => {
    const { classes, onSearch } = props

      

    const [loading, setLoading] = useState(true)
    const [options, setOptions] = useState({
        languages: trainingLanguageCourse, 
        trainingType: [
            { 
                label: 'DVD', 
                value: 'DVD' 
            },
            { 
                label: 'Zoom', 
                value: 'Zoom' 
            },
            {
                label: 'Online', 
                value: 'Online'
            }
        ],
    })
    const [search, setSearch] = useState({
        fromDate: '',
        toDate: '',
        languages: null,
        trainingType: null,
        company: '',
        limit: '',
    })

    useEffect(()=>{
        setLoading(false);

    }, []);


    // handle updating state
    const handleChange = event => {
        event.persist()
        const { name, value } = event.target

        setSearch(prevSearch => ({
            ...prevSearch,
            [name]: value
        }))
    }

    const handleSearch = () => {
        sessionStorage.setItem('searchCatLevelRegionFirstLast', JSON.stringify(search))
        onSearch(search)
    }

    const onChange = event => {
        setSearch({
            ...search,
            [event.target.name]: event.target.value
        });
    }

    return (
        <>
            {
                loading ? <Loading /> :
                <Grid container spacing={3}>
                    <GridAutoTextField
                        xs={12}
                        md={3}
                        name="languages"
                        options={options.languages}
                        getOptionLabel={(option) => option.label || "" }
                        getOptionSelected={(option, val) => val === null || option.value === val.value}
                        value={search.languages}
                        onChange={handleChange}
                        classes={classes}
                        label="Languages/Courses"
                    />
                    <GridAutoTextField
                        xs={12}
                        md={3}
                        name="trainingType"
                        options={options.trainingType}
                        getOptionLabel={(option) => option.label  || "" }
                        getOptionSelected={(option, val) => val === null || option.value === val.value}
                        value={search.trainingType}
                        onChange={handleChange}
                        classes={classes}
                        label="Training Type"
                    />
                    <Grid item xs={12} sm={3}>
                            <TextField
                                id="fromDate"
                                label="From"
                                type="date"
                                name='fromDate'
                                value={search.fromDate}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                            <TextField
                                id="toDate"
                                label="To"
                                type="date"
                                name='toDate'
                                value={search.toDate}
                                className={[classes.textField].join(' ')}
                                onChange={onChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                name='limit'
                                label="limit"
                                type="number"
                                value={search.limit}
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                         </Grid>
                         <Grid item xs={12} sm={3}>
                            <TextField
                                name='company'
                                label="Company"
                                type="text"
                                value={search.company}
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                         </Grid>
                    <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                        <Button variant="contained" color="primary" type="submit" className={[].join(' ')} onClick={handleSearch} >Search</Button>
                        {/* {disabled && <p>Enter a username or last name</p>} */}
                    </Grid>
                </Grid>}
        </>
    )
}

export const SearchBarManageTrainingCode = props => {
    const { classes, onSearch } = props

    const [loading, setLoading] = useState(true)
    const [options, setOptions] = useState({
        languages: trainingLanguageCourse, 
        trainingType: [
            { 
                label: 'DVD', 
                value: 'DVD' 
            },
            { 
                label: 'Zoom', 
                value: 'Zoom' 
            }
        ],
    })
    const [search, setSearch] = useState({

        languages: null,
        trainingType: null,
        trainingCode: '',
    })

    // const [disabled, setDisabled] = useState(true) // if the search button is disabled or not

    // // handle the button disabling if both fields are undefined
    // useEffect(() => {
    //     if (search.username === '' && search.lastName === '') setDisabled(true)
    //     else setDisabled(false)
    // }, [search.username, search.lastName])

    useEffect(()=>{
        setLoading(false);

    }, []);


    // handle updating state
    const handleChange = event => {
        event.persist()
        const { name, value } = event.target

        setSearch(prevSearch => ({
            ...prevSearch,
            [name]: value
        }))
    }

    const handleSearch = () => {
        sessionStorage.setItem('searchCatLevelRegionFirstLast', JSON.stringify(search))
        onSearch(search)
    }

    const onChange = event => {
        setSearch({
            ...search,
            [event.target.name]: event.target.value
        });
    }

    return (
        <>
            {
                loading ? <Loading /> :
                <Grid container spacing={3}>
                    <Grid item xs={12} md ={6} lg={6}>
                            <TextField
                                name='trainingCode'
                                label="Training Code"
                                type="text"
                                value={search.trainingCode}
                                className={[classes.textField].join(' ')}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                         </Grid>
                    {/* <GridAutoTextField
                        xs={12}
                        md={3}
                        name="languages"
                        options={options.languages}
                        getOptionLabel={(option) => option.label || "" }
                        getOptionSelected={(option, val) => val === null || option.value === val.value}
                        value={search.languages}
                        onChange={handleChange}
                        classes={classes}
                        label="Languages"
                    /> */}
                    <GridAutoTextField
                        xs={12}
                        md={6}
                        name="trainingType"
                        options={options.trainingType}
                        getOptionLabel={(option) => option.label  || "" }
                        getOptionSelected={(option, val) => val === null || option.value === val.value}
                        value={search.trainingType}
                        onChange={handleChange}
                        classes={classes}
                        label="Training Type"
                    /> 
                         
                    <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                        <Button variant="contained" color="primary" type="submit" className={[].join(' ')} onClick={handleSearch} >Search</Button>
                        {/* {disabled && <p>Enter a username or last name</p>} */}
                    </Grid>
                </Grid>}
        </>
    )
}

export const SearchBarCourseTitle = props => {
    const [search, setSearch] = useState({ title: '' })

    // handle updating state
    const handleChange = event => {
        event.persist()
        const { name, value } = event.target

        setSearch(prevSearch => ({
            ...prevSearch,
            [name]: value
        }))
    }

    const handleSearch = () => {
        props.onSearch(search)
    }

    return (
        <>

            <Grid container spacing={3}>
                <Grid item xs={12} >
                    <TextField
                        name='title'
                        label="Course Title"
                        type="text"
                        value={search.title}
                        className={[].join(' ')}
                        onChange={handleChange}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center", alignSelf: "flex-end" }}>
                    <Button variant="contained" color="primary" type="submit" className={[].join(' ')} onClick={handleSearch} >Search</Button>
                </Grid>
            </Grid>
        </>
    )
}

export default SearchBarFirstLastRequired